import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './ListPage.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://saskararecord.com/api';

export default function StoreList() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_BASE}/products/public?limit=100`)
      .then((res) => setProducts(res.data.data || []))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="list-page">
      <nav className="list-page__nav">
        <Link to="/" className="list-page__back">← Beranda</Link>
      </nav>

      <h1 className="list-page__title">Store</h1>

      {loading ? (
        <p className="list-page__empty">Memuat...</p>
      ) : products.length === 0 ? (
        <p className="list-page__empty">Belum ada produk tersedia saat ini. Cek lagi nanti!</p>
      ) : (
        <div className="list-page__grid">
          {products.map((p) => (
            <Link to={`/store/${p.slug}`} className="list-card" key={p.id}>
              <div className="list-card__photo">
                {p.photo_url ? (
                  <img src={p.photo_url} alt={p.name} />
                ) : (
                  <div className="list-card__photo-fallback" />
                )}
              </div>
              <div className="list-card__body">
                {p.artist_name && <p className="list-card__date">{p.artist_name}</p>}
                <h3 className="list-card__title">{p.name}</h3>
                <p className="list-card__price">Rp {Number(p.price).toLocaleString('id-ID')}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
